import { useIsAuthenticated } from '@interhyp/platform-auth';
import { SET_LOGIN_STATUS, SET_USER_ROLE, useTracking } from '@interhyp/util-tracking';
import { useEffect } from 'react';

import { useIsBroker } from './useIsBroker';
import { useIsCustomer } from './useIsCustomer';
import { useIsFb } from './useIsFb';

export function useSessionTracking(): void {
  useUserTypeTracking();
  useAuthTracking();
}

function useUserTypeTracking() {
  const { trackEvent } = useTracking();
  const isCustomer = useIsCustomer();
  const isBroker = useIsBroker();
  const isFb = useIsFb();

  useEffect(() => {
    let userRole: string | undefined;

    if (isCustomer) {
      userRole = 'Kunde';
    } else if (isFb) {
      userRole = 'FB';
    } else if (isBroker) {
      userRole = 'Vermittler';
    }

    if (userRole) {
      trackEvent({
        type: SET_USER_ROLE,
        userRole,
      });
    }
  }, [trackEvent, isCustomer, isFb, isBroker]);
}

function useAuthTracking() {
  const { trackEvent } = useTracking();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated) {
      trackEvent({
        type: SET_LOGIN_STATUS,
        loginStatus: 'logged in',
      });
    } else {
      trackEvent({
        type: SET_LOGIN_STATUS,
        loginStatus: 'logged out',
      });
    }
  }, [isAuthenticated, trackEvent]);
}
